import Vue from "vue";
import Router from "vue-router";

import Login from "views/Login.vue"; // 登录页面
import LeftMenu from 'components/LeftMenu.vue' // 左侧的菜单栏
import UncollectedOrder from 'views/UncollectedOrder.vue' // 未领订单
import ReceiveOrder from 'views/ReceiveOrder.vue' // 已领订单
import ReceiveOrderDetail from 'views/ReceiveOrderDetail.vue' // 已领订单详情
import CreateOrder from 'views/CreateOrder.vue' // 创建订单
import NewOrderList from 'views/NewOrderList.vue' // 查看正式订单
import NewOrderDetail from 'views/NewOrderDetail.vue'
import { getCookie } from "common/js/mUtils.js";

Vue.use(Router);

const routersList = [
  {
    path: "/",
    name: "login",
    component: Login // 登录
  },
  {
    path: '/uncollectedOrder',
    name: '',
    component: LeftMenu,
    children:[{
      path: '',
      name: 'uncollectedOrder',
      component: UncollectedOrder,
      meta: {
        title: '未领订单',
        requireAuth: true
      }
    }, {
      path: '/receiveOrder',
      name: 'receiveOrder',
      component: ReceiveOrder,
      meta: {
        title: '已领订单',
        requireAuth: true
      }
    }, {
      path: '/receiveOrderDetail',
      name: 'receiveOrderDetail',
      component: ReceiveOrderDetail,
      meta: {
        title: '已领订单',
        breadcrumb: [
          {
            name: '已领订单修改',
            path: '/receiveOrderDetail'
          }
        ],
        requireAuth: true
      }
    }, {
      path: '/createOrder',
      name: 'createOrder',
      component: CreateOrder,
      meta: {
        title: '创建订单',
        requireAuth: true
      }
    }, {
      path: '/newOrderList',
      name: 'newOrderList',
      component: NewOrderList,
      meta: {
        title: '正式订单列表',
        requireAuth: true
      }
    }, {
      path: '/newOrderDetail',
      name: 'newOrderDetail',
      component: NewOrderDetail,
      meta: {
        title: '正式订单',
        breadcrumb: [
          {
            name: '订单详情',
            path: '/newOrderDetail'
          }
        ],
        requireAuth: true
      }
    }]
  }
];

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: routersList
});

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    let userId = getCookie("u_uuid_userId");
    if (!userId) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;